import React, { useState, useEffect, useRef, useCallback } from 'react';
import StartScreen from '../components/StartScreen';
import SnakeGameAutopilot from '../components/SnakeGameAutopilot';
import FactCard from '../components/FactCard';
import EndScreen from '../components/EndScreen';
import { facts } from '../data/facts';
import '../styles/SnakePortfolio.css';

const SnakePortfolio = () => {
  const [gameState, setGameState] = useState('start'); // 'start', 'playing', 'end'
  const [currentFactIndex, setCurrentFactIndex] = useState(0);
  const [showFactCard, setShowFactCard] = useState(false);
  const [completedFacts, setCompletedFacts] = useState([]);

  const handleStartGame = () => {
    setGameState('playing');
    setCurrentFactIndex(0);
    setCompletedFacts([]);
    setShowFactCard(false);
  };

  const handleFoodEaten = () => {
    if (currentFactIndex < facts.length) {
      setShowFactCard(true);
    }
  };

  const handleFactDismiss = () => {
    setShowFactCard(false);
    const newCompleted = [...completedFacts, currentFactIndex];
    setCompletedFacts(newCompleted);
    
    if (currentFactIndex === facts.length - 1) {
      // All facts shown, end game
      setTimeout(() => {
        setGameState('end');
      }, 500);
    } else {
      setCurrentFactIndex(currentFactIndex + 1);
    }
  };

  const handlePlayAgain = () => {
    setGameState('start');
    setCurrentFactIndex(0);
    setCompletedFacts([]);
    setShowFactCard(false);
  };

  return (
    <div className="snake-portfolio">
      {gameState === 'start' && <StartScreen onStart={handleStartGame} />}
      
      {gameState === 'playing' && (
        <>
          <SnakeGameAutopilot
            onFoodEaten={handleFoodEaten}
            currentFactIndex={currentFactIndex}
            isPaused={showFactCard}
            completedFacts={completedFacts}
          />
          {showFactCard && (
            <FactCard
              fact={facts[currentFactIndex]}
              onDismiss={handleFactDismiss}
            />
          )}
        </>
      )}
      
      {gameState === 'end' && (
        <EndScreen onPlayAgain={handlePlayAgain} />
      )}
    </div>
  );
};

export default SnakePortfolio;
